import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getRejectReasons = createAsyncThunk(
  '/getRejectReasons',
  async () => {
    const response = await axios.get('/GetRejectReasons');
    return response.data;
  }
);
export const getRejectReasonList = createAsyncThunk(
  '/getRejectReasonList',
  async () => {
    const response = await axios.get('/GetRejectReasonList');
    return response.data;
  }
);
export const getRejectReasonDetails = createAsyncThunk(
  '/getRejectReasonDetails',
  async (id) => {
    const response = await axios.get(`/GetRejectReasonDetails/${id}`);
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const rejectReasonSlice = createSlice({
  name: 'rejectReason',
  initialState: {
    loading: false,
    error: '',
    rejectReasons: [],
    rejectReasonList: [],
    rejectReasonDescriptions: [],
    SelectedAppTranslationId: 0,
    Type: '',
    rejectReasonType: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    changeType(state, action) {
      state.Type = action.payload;
      //state.rejectReasonType = state.rejectReasonList.find((m) => m.Description === state.Type).ID;
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    resetDescriptions(state) {
      state.rejectReasonDescriptions = [];
    }
    
  },

  extraReducers: {
    [getRejectReasons.pending]: (state) => {
      state.loading = true;
    },
    [getRejectReasons.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRejectReasons.fulfilled]: (state, action) => {
      state.rejectReasons = action.payload;
      state.loading = false;
    },
    [getRejectReasonDetails.pending]: (state) => {
      state.loading = true;
    },
    [getRejectReasonDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRejectReasonDetails.fulfilled]: (state, action) => {
      state.rejectReasonDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: (state) => {
      state.loading = true;
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.rejectReasonDescriptions = action.payload;
      state.loading = false;
    },
    [getRejectReasonList.pending]: (state) => {
      state.loading = true;
    },
    [getRejectReasonList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRejectReasonList.fulfilled]: (state, action) => {
      state.rejectReasonList = action.payload;
      state.loading = false;
    }
  }
});

export const rejectReasonActions = rejectReasonSlice.actions;

export default rejectReasonSlice;
